import Swal from "sweetalert2";

require('./bootstrap-aleado')

//require('./aleado/mdb');
//require('./aleado/mdb.lite');
import * as mdb from 'mdb-ui-kit'; // lib
window.mdb = mdb;
/*import { Ripple, initMDB } from 'mdb-ui-kit/js/mdb.min.js'; // Import needed modules

window.Ripple = Ripple;

initMDB({ Ripple }) */// Initialize imported modules to enable data-attribute init

require('./aleado/action-menu-aleado');
import validate from "jquery-validation";
require('./aleado/script-aleado');

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    onOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})
window.Swal = Swal;
window.Toast = Toast;
//import DataTable from 'datatables.net';
//import 'datatables.net-responsive-dt';
//require('datatables.net-responsive-dt/js/responsive.dataTables');
//require('datatables.net-responsive-bs4/js/responsive.bootstrap4.min');

//require('datatables.net-dt');
//require('datatables.net-responsive-dt');


//import 'https://cdn.datatables.net/2.0.8/js/dataTables.js';
//import 'https://cdn.datatables.net/responsive/3.0.2/js/dataTables.responsive.js';
/*import 'https://cdn.datatables.net/responsive/2.2.9/js/responsive.bootstrap4.min.js';*/
//require('./responsive.bootstrap4.min');


